import isInstanceof from "@homer.utility/validator.isinstanceof";
import isString from "@homer.utility/validator.isstring";

/**
 * Class Template
 */
class Template extends DocumentFragment {
    /**
     * Constructor
     *
     * @param {string|DocumentFragment} template
     *
     * @returns {DocumentFragment}
     */
    constructor(template) {
        super();

        const isTemplateString = isString(template);
        const fragment = isTemplateString ? document.createRange().createContextualFragment(template) : template;

        if (!isInstanceof(fragment, DocumentFragment)) {
            throw new TypeError(
                "Argument `template` must be of type `DocumentFragment` or `string` resolving to `DocumentFragment`",
            );
        }

        // Contextual parsing already creates a detached fragment in the current document.
        return isTemplateString ? fragment : document.importNode(fragment, true);
    }
}

export default Template;
